import { AxiosResponse } from 'axios';
import FileSaver from 'file-saver';

import { ClientService } from '@/types/api';

export class FilesApi {
	private prefix = 'files';

	constructor(private readonly clientService: ClientService) {
		this.clientService = clientService;
	}

	public async getFile(fileUrl: string | number, abs: boolean = false): Promise<AxiosResponse<Blob>> {
		if (abs) {
            return this.clientService.get(fileUrl as string, {
                responseType: 'blob',
                baseURL: '/',
            });
        }
		return this.clientService.get(`${this.prefix}/${fileUrl}`, {
			responseType: 'blob',
		});
	}

	public async saveFile(fileId: string | number, filename: string): Promise<void> {
		const { data } = await this.getFile(fileId);

		FileSaver.saveAs(data, filename);
	}

	public async saveFileByFullUrl(fileUrl: string, filename: string): Promise<void> {
		const { data } = await this.getFile(fileUrl, true);
        const ext = fileUrl.split('.').pop();
		FileSaver.saveAs(data, `${filename}.${ext}`);
	}

	public async deleteFile(fileId: string | number): Promise<AxiosResponse> {
		return this.clientService.delete(`${this.prefix}/${fileId}`);
	}
}
